<template>
  <div class="home-container">
    <!-- 门店维护 -->
    <NavHeaderBar :showSearch="false" :isLeft="true" :navBarTitle="$t('shared.storeOperation')" @backReturn="backReturn">
      <div class="right-header">
        <img class="search-img icon-img" src="@/assets/images/search_news.png" alt="" @click="toPage(`/storeMaintain/search`)">
      </div>
    </NavHeaderBar>
    <FilterCustom ref="filterCustom" :pageType="pageType" :deptOption="deptOption" @changeFilter="confirmFilter" />
    <div class="tag-tabs">
      <van-tabs type="card" v-model="tagVal" color="#307bff" background="#fff" :ellipsis="false" @change="handleTab">
        <van-tab v-for="(subItem, subIndex) in storeTagTypeList" :title="subItem.label" :key="subIndex" :name="subItem.value"></van-tab>
      </van-tabs>
    </div>
    <div class="tabs-content">
      <!-- <van-sticky :offset-top="48">
        <FilterCustom ref="filterCustom" :pageType="pageType" :deptOption="deptOption" @changeFilter="confirmFilter" />
        <div class="tag-tabs">
          <van-tabs type="card" v-model="tagVal" color="#307bff" background="#fff" :ellipsis="false" @change="handleTab">
            <van-tab v-for="(subItem, subIndex) in storeTagTypeList" :title="subItem.label" :key="subIndex" :name="subItem.value"></van-tab>
          </van-tabs>
        </div>
      </van-sticky> -->
      <van-pull-refresh v-model="isLoading" @refresh="pullDownRefreshFn">
        <van-list v-model="loading" :finished="finished" finished-text="There's nothing more！" offset="60" :immediate-check="false" @load="pullUpLoadMoreFn">
          <Store ref="storeRef" :arr="storeList" @getCurrentLoc="getCurrentLoc" @getItemData="getItemData" />
        </van-list>
      </van-pull-refresh>
    </div>
    <DragButton :extraTop="-70" @click.stop="toPage(`/store/storeGroup?pageType=${pageType}`)">
      <div class="icon-add" style="background-color: #e8effc;"><img class="map-img" src="@/assets/images/group_img.png" alt=""></div>
    </DragButton>
    <DragButton @click.stop="toPage('/storeMap')">
      <div class="icon-add"><img src="@/assets/images/u76.png" class="map-img" alt=""></div>
    </DragButton>
  </div>
</template>

<script>
import { arsCustomerAppListPageApi, deptTreeDeptApi } from '@/api/home'
import { Toast } from 'vant'
import Store from './components/store'
import FilterCustom from '@/components/FilterCustom'
import DragButton from '@/components/dragButton'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'StoreMaintain',
  components: {
    Store,
    FilterCustom,
    DragButton
  },
  data () {
    return {
      isLoading: false, // 下拉的加载状态
      loading: false, // 上拉每一页的加载状态
      finished: false, // 上拉是否全部加载完毕
      storeList: [], // 文字列表
      paginationList: {
        page: 1,
        limit: 15,
        total: 0
      },
      geocoder: null,
      pageType: 'storeMaintain',
      deptOption: [],
      filterData: {
        sortVal: 'distance-0',
        sortLabel: this.$t('shared.filter.distanceNearest'),
        customerTag: '',
        shelfOperate: '',
        shelfProductIdList: [],
        deptIdList: [],
        userIdList: [],
        personVal: [],
        incentiveType: '',
        isPopUpEvent: '',
        isVisit: '',
        visitDay: '',
        visitStartDay: '',
        visitEndDay: '',
        reorderProductIdList: [],
        reorderOperate: '1',
        visitByBaVal: [''],
        visitUserIdList: [],
        isLastVisit: false
      },
      customerId: '',
      checkedData: {
        lat: '',
        lng: ''
      },
      storeTagTypeList: [
        { label: this.$t('shared.filter.all'), value: '' },
        { label: this.$t('shared.filter.sVIPCore'), value: 1 },
        { label: this.$t('shared.filter.vIPCore'), value: 2 },
        { label: this.$t('shared.filter.potential'), value: 3 },
        { label: this.$t('shared.filter.toBeVerified'), value: '0' }
      ],
      tagVal: ''
    }
  },

  watch: {
    $route (newVal) {
      this.$nextTick(() => {
        if (this.$route.meta.scrollY) {
          window.scrollTo(0, this.$route.meta.scrollY)
        }
      })
    }
  },

  // 路由离开前
  beforeRouteLeave (to, from, next) {
    // 可以访问组件实例 `this`
    // 把滚动的高度 保存到 路由对象的meta字段中的scrollY上
    from.meta.scrollY = window.scrollY
    next()
  },
  // mounted() {
  //   console.log('mounted')
  //   // this.geocoder = new google.maps.Geocoder()
  // },
  activated () {
    // 一进入Home页面，需要立即 发送请求，拿数据，铺页面
    // this.getStoreData()
    // 页面切回来，自动滚动到 上次 保存的 滚动位置
    // window.scrollTo(x, y)
    // this.$nextTick(() => {
    //   window.scrollTo(0, this.$route.meta.scrollY)
    // })
    this.paginationList.page = 1
    this.getMyVisit()
    this.resetPage()
    this.isLoading = false
    // this.filterData.projectId = this.globalData.projectList[0].id
    // this.filterData.projectName = this.globalData.projectList[0].projectName
    // this.$refs[`filterCustom`].setDefaultVal('projectId', this.globalData.projectList[0])
    this.getStoreData()
    // this.pullDownRefreshFn()
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo',
      globalData: 'globalData'
    })
  },
  methods: {
    ...mapMutations(['setStoreMaintainFilter']),
    handleTab (val) {
      const data = {
        ...this.filterData,
        customerTag: val ? Number(val) : ''
      }
      this.confirmFilter(data)
      this.$refs.filterCustom.filterData[this.pageType].customerTag = val ? Number(val) : ''
    },
    getCurrentLoc (params) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getlocation(currentTimeLoc.lat, currentTimeLoc.lng, params.address)
    },
    getlocation (lat, lng, toAddress) {
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${toAddress}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    confirmFilter (data) {
      this.filterData = data
      this.tagVal = data.customerTag === 0 ? '0' : data.customerTag
      this.paginationList.page = 1
      this.storeList = []
      this.finished = false
      this.loading = false
      this.getStoreData(true)
      this.isLoading = false
    },
    // 获取频道文字列表xxxaaaxx
    async getStoreData (isPullDown = false) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // 三星手机不能频繁获取当前定位
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getStoreListData(currentTimeLoc)
    },
    getStoreListData (currentTimeLoc = {}) {
      const {
        personVal,
        userIdList,
        visitDay,
        visitStartDay,
        visitEndDay,
        visitByBaVal,
        visitUserIdList,
        sortVal
      } = this.filterData
      const data = {
        ...this.paginationList,
        ...this.filterData,
        userIdList: personVal.includes('Me')
          ? [...userIdList, this.userInfo.user.id]
          : userIdList,
        visitStartDay: visitDay === 'customizable' ? visitStartDay : visitDay ? visitDay.split('@')[0] : '',
        visitEndDay: visitDay === 'customizable' ? visitEndDay : visitDay ? visitDay.split('@')[1] : '',
        visitUserIdList: visitByBaVal.includes('Me') ? [...visitUserIdList, this.userInfo.user.id] : visitByBaVal.includes('') ? [] : visitUserIdList,
        sortField: sortVal ? sortVal.split('-')[0] : '',
        order: sortVal ? sortVal.split('-')[1] : '',
        ...currentTimeLoc,
        search: ''
      }
      arsCustomerAppListPageApi(data)
        .then((result) => {
          Toast.clear()
          if (this.paginationList.page === 1) {
            this.storeList = []
          }
          // 没有就去请求
          this.paginationList.total = result.data.totalRow
          result.data.list.forEach(subItem => {
            subItem.newShelfList = subItem.shelfList.map(shelfItem => shelfItem.productName)
          })
          // 把新数组 与 原来的 数组 进行 合并
          this.storeList = [...this.storeList, ...result.data.list]
          // 把 loading 设置为false，表示 可以进行 下一次请求了
          this.paginationList.page++
          this.loading = false
          if (this.storeList.length === Number(this.paginationList.total)) {
            this.finished = true
          }
        })
        .catch(() => {})
    },

    // 上拉加载更多
    pullUpLoadMoreFn () {
      // 切换频道的时候，只有articleList 不为空，才触发 上拉加载更多的函数
      if (this.storeList.length > 0) {
        // 1. 发请求 2. 拿数据，合并
        this.getStoreData()
      }
    },
    getMyVisit () {
      deptTreeDeptApi().then((res) => {
        this.deptOption = this.stripInPlace(res.data)
      })
    },
    stripInPlace (list) {
      list.forEach((node) => {
        if (Array.isArray(node.children)) {
          if (node.children.length) {
            this.stripInPlace(node.children)
          } else {
            delete node.children
          }
        }
      })
      return list
    },
    // 下拉刷新
    pullDownRefreshFn () {
      // this.storeList = []
      this.resetPage()
      this.getStoreData(true)
      this.isLoading = false
    },
    resetPage () {
      this.paginationList = {
        page: 1,
        limit: 15,
        total: 0
      }
      this.storeList = []
      this.finished = false
      this.loading = false
    },
    toPage (url) {
      if (url === '/storeMap') {
        const newLat = ''
        const newLng = ''
        const urlParams = `lat=${newLat}&lng=${newLng}&pageType=${this.pageType}`
        // window.localStorage.setItem('firstMap', '1')
        this.setStoreMaintainFilter({ ...this.filterData, sortVal: '', sortLabel: '' })
        this.$router.push(`${url}?${urlParams}`)
      } else {
        this.$router.push(url)
      }
    },
    getItemData (data) {
      this.customerId = data.id
      this.checkedData = data
    },
    backReturn () {
      this.$destroy()
    }
  }
}
</script>

<style scoped lang="less">
.home-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f5f5f9;
  .search-content {
    padding: 8px 10px;
    /deep/.van-cell {
      line-height: 20px;
    }
  }
  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }
  .van-cell-info {
    // position: relative;
    display: flex;
    justify-content: space-between;
    // top: 53px;
    height: 35px;
    padding: 0 10px;
    font-size: 12px;
    background-color: #dce5f6;
    .channel-total {
      display: flex;
      align-items: center;
      flex: 1;
      .label-name {
        width: 60px;
      }
      .label-value {
        flex: 1;
        width: 66px;
      }
    }
    .channel-filter {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 50%;
      padding-left: 10px;
      border-left: 1px solid #c8d6f1;
      &:first-child {
        border-left: none;
      }
      .filter-label {
        flex: 1;
      }
    }
  }
  .tag-tabs {
    padding: 10px 0;
    background-color: #fff;
  }
  /deep/.van-tabs {
    .van-tabs__nav {
      margin: 0;
      border: none !important;
    }
    .van-tab {
      border: 1px solid #307bff;
      border-radius: 16px;
      background-color: #fff;
      color: #307bff !important;
      font-size: 12px;
      margin-right: 5px;
      &:last-child {
        margin-right: 0;
      }
    }
    .van-tab--active {
      color: #fff !important;
    }
  }
  .tabs-content {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    padding-bottom: 43px;
  }
  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
      font-size: 16px;
    }
  }
  .map-img {
    width: 30px;
    height: 30px;
  }
  /deep/.van-pull-refresh {
    .van-list {
      background-color: #fff;
    }
  }
  /deep/.van-sticky {
    z-index: 999;
  }
}
</style>
